import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';

import {
    BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN,
    IBetslipMessagesProviderService,
} from '../../../../../base/services/betslip-messages-provider.service';
import { BetPlacementError } from '../../../errors/bet-placement-error';
import { BetslipError } from '../../../errors/betslip-error';
import { OverallMaxWinPerUser } from '../../../errors/user/overall-max-win-per-user';
import { ErrorMessageCurrencySymbolFormatService } from '../error-message-currency-symbol-format.service';
import { IExtendedMessage, MessageFormatter } from './message-formatter';

@Injectable()
export class OverallMaxWinPerUserMessageFormatter extends MessageFormatter<OverallMaxWinPerUser> {
    private readonly stakeUpdatedTitle: string;

    constructor(
        @Inject(BETSLIP_MESSAGES_PROVIDER_INJECTION_TOKEN) betslipMessagesProvider: IBetslipMessagesProviderService,
        private errorMessageCurrencySymbolFormatService: ErrorMessageCurrencySymbolFormatService,
    ) {
        super();

        this.stakeUpdatedTitle = betslipMessagesProvider.getMessages().common.overallMaxWinPerUserExceeded_StakeUpdated_Title;
    }

    format(error: BetPlacementError): Observable<IExtendedMessage> {
        const message = this.errorMessageCurrencySymbolFormatService.updateCurrencyPlaceholders(error.errorMessage);

        const title = this.stakeUpdatedTitle;

        return of({ message, title });
    }

    canHandle(error: BetslipError): boolean {
        return error instanceof OverallMaxWinPerUser && !!error.errorMessage;
    }
}
